import React from 'react';

const Intro: React.FC = () => {
  return (
    <section className="intro">
      <div className="container intro-container">
        <p className="intro-statement">
          PH Therapy empowers high-performing individuals, CEOs, partners, and corporate leaders to live pain-free, active lives. We specialise in clinical, chronic, and complex conditions: musculoskeletal (MSK), oncology rehabilitation, and lifestyle management. Our AHCS-registered Clinical Exercise Physiologists deliver personalised, evidence-based programmes across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex.
        </p>
      </div>
    </section>
  );
};

export default Intro;
